import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import { getAllData } from '../apis/generalApis'
import { Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const CancellationPolicyModal = ({
  handleCancellationPolicyModal,
  modalOpen = false,
}) => {
  const [cancellationPolicy, setCancellationPolicy] = React.useState('')
  React.useEffect(() => {
    getCancellationPolicy()
  }, [])

  const getCancellationPolicy = async () => {
    let result = await getAllData('show-cancellation-policy')
    if (result?.success === true && result?.data != null) {
      setCancellationPolicy(result?.data?.description)
    }
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleCancellationPolicyModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="privacy-policy-modal">
          <h3 className="fs-24 mb-3 fw-bold">Cancellation Policy</h3>
          <div className="text-left">
            <p className="fs-16 font-weight-bold mb-1">Cancellation Policy</p>
            <p className="fs-14">{cancellationPolicy}</p>
            <div
              className="mt-5 pointer"
              onClick={() => handleCancellationPolicyModal(false)}
            >
              <Button fullWidth id="btn-primary-no-shadow">Continue</Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default CancellationPolicyModal
